module.exports = __webpack_public_path__ + "static/media/ins3.09f92d61.jpg";